<template>
  <list-component entityName="contingent_hotel" title="Liste des hôtels" :buttonGroup="true" />
</template>

<script>
import axios from "axios";
import listComponent from '@/components/backoffice/listComponent'

export default {
  components: {
    listComponent,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
</style>
